import UserInfo from './UserInfo'

export default UserInfo
export { renderUserName } from './UserInfo'
